// Convenience hook — wraps lib/permissions with live opts + role.
// Honors V1 "elevated partner" behavior: PMs listed in team.elevatedMembers
// operate as admin against the owner's data.

import { useOpts } from './useOpts'
import { useAuth } from './useAuth'
import { useTeam } from './useTeam'
import { getRole, can, getVisibleTabs } from '../lib/permissions'
import type { Permission } from '../lib/permissions'
import type { Role } from '../types'

export interface Permissions {
  role: Role
  can: (perm: Permission) => boolean
  tabs: string[]
}

export function usePermissions(): Permissions {
  const opts = useOpts()
  const { user } = useAuth()
  const { team } = useTeam()
  const role = getRole(opts, {
    userEmail: user?.email ?? null,
    elevatedMembers: team?.elevatedMembers,
  })

  return {
    role,
    can: (perm: Permission) => can(perm, role, opts),
    tabs: getVisibleTabs(role, opts),
  }
}
